import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import * as actionTypes from "../redux/actions";

import { Row, Col, Button, ListGroup, ListGroupItem, Badge } from "reactstrap";
import { spinnerService } from "@chevtek/react-spinners";
import imgPlaceholder from "../assets/img/logo-placeholder.jpg";
import createAbsoluteGrid from "react-absolute-grid";
import VehicleCard from "../components/Dashboard/VehicleCard";
import gql from "graphql-tag";
import DashboardView from "./NewDashboard";
import { mainDashboardQuery } from "../data/customQueries";
import { getCustomerTeam } from "../graphql/queries";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import * as _ from "lodash";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import AppsIcon from "@material-ui/icons/Apps";
import ListIcon from "@material-ui/icons/List";
import Avatar from "@material-ui/core/Avatar";
import VehicleListView from "../components/Dashboard/vehisleListView";
import IconButton from "@material-ui/core/IconButton";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Modal from "@material-ui/core/Modal";
import { Storage } from "aws-amplify";
import { Typography } from "@material-ui/core";
Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
let regType = "";
const CustomerDashboardPage = ({
  client,
  user,
  vehicleGrid,
  storeVehicleGrid,
  history
}) => {
  const [data, setData] = useState({});
  const [dispData, setDispData] = useState({});
  const [isDisp, setIsDisp] = useState(false);
  const [newDefects, setNewDefects] = useState(0);
  const [redTags, setRedTags] = useState(0);
  const [onTheFly, setOnTheFly] = useState(0);
  const [dvir, setDvir] = useState(0);
  const [vehicleCount, setVehicleCount] = useState(0);
  const [logo, setLogo] = useState(imgPlaceholder);
  const [driverCount, setDriverCount] = useState(0);
  const [view, setView] = useState("");
  const [vehiclesList, setVehiclesList] = useState([]);
  const [defectsList, setDefectsList] = useState([]);
  const [open, setOpen] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [initialFetch, setInitialFetch] = useState(true);
  const [searching, setSearching] = useState(false);

  let vehicleDispData = [];
  let vehicleCardDispData = [];
  let searchArr = [];
  const getData = async () => {
    let today = new Date();
    let dueDate = moment(today).add(15, "days");
    spinnerService.show("mySpinner");
    let custUsername = user.username;
    let userType = null;
    if (
      user !== null &&
      user !== "notFound" &&
      user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
    ) {
      userType = user.signInUserSession.idToken.payload["cognito:groups"][0];
    }
    if ((userType === "Dispatchers") | (userType === "Technicians")) {
      setIsDisp(true);
      let custTeam = (await client.query({
        query: gql(getCustomerTeam),
        fetchPolicy: `network-only`,
        variables: { id: user.username }
      })).data.getCustomerTeam;
      custUsername = custTeam.customer.id;
      setDispData(custTeam);
    }

    try {
      let res = null;

      res = (await client.query({
        query: gql(mainDashboardQuery),
        fetchPolicy: `network-only`,
        variables: { id: custUsername, dueDate: dueDate, limit: 1000 }
      })).data.getCustomer;
      regType = res.registeredInspectionType;
      
      setData(res);
      setDefectsList(res.defectsByStatus.items);
      let pic = res.picture;
      if (pic !== null) {
        if (pic !== undefined) {
          Storage.get(pic.key)
            .then(pictureObj => {
              setLogo(pictureObj);
            })
            .catch(err => {});
        }
      }
      if (res.vehicles.items !== null) {
        setVehicleCount(res.vehicles.items.length);
        let index = 0;
        await res.vehicles.items.forEach(item => {
          index++;
          let vehDefectCount = 0;
          let redTagCheck = false;
          let dispObj = {
            key: index,
            redTag: false,
            customerVehicleId: item.customerVehicleId,
            VIN: item.VIN,
            id: item.id,
            sort: 0,
            vehCategory: item.vehicleType.vehicleCategory,
            mainPic: item.mainPic,
            make: item.make,
            model: item.model,
            history: history,
            deactivateBIT: item.deactivateBIT,
            regType: res.registeredInspectionType,
            customer: custUsername,
            redTagCounter: 0,
            status: item.vehicleStatus
          };
          if (
            !(
              item.nextInspectionDue === undefined ||
              item.nextInspectionDue === null
            )
          ) {
            if (item.nextInspectionDue.length > 0) {
              dispObj.nextInspectionDue = item.nextInspectionDue;
            }
          }

          if (res.registeredInspectionType !== "FEDERAL_BIT") {
            if (
              !(
                item.nextInspectionDue === undefined ||
                item.nextInspectionDue === null
              )
            ) {
              if (item.nextInspectionDue.length > 0) {
                dispObj.nextDue = ["", null, undefined].includes(
                  item.nextInspectionDue[0].nextDueDate
                )
                  ? null
                  : item.nextInspectionDue[0].nextDueDate;
              }
            }
          } else if (res.registeredInspectionType === "FEDERAL_BIT") {
            const date1 =
              item.nextInspectionDue && item.nextInspectionDue.length > 0
                ? item.nextInspectionDue[0].nextDueDate
                : null;
            const date2 =
              item.nextInspectionDue && item.nextInspectionDue.length > 1
                ? item.nextInspectionDue[1].nextDueDate
                : null;

            if (
              ["", null, undefined].includes(date1) &&
              ["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = null;
            } else if (
              ["", null, undefined].includes(date1) &&
              !["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = date2;
            } else if (
              !["", null, undefined].includes(date1) &&
              ["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = date1;
            } else if (
              !["", null, undefined].includes(date1) &&
              !["", null, undefined].includes(date2)
            ) {
              if (moment(new Date(date2)).isBefore(new Date(date1))) {
                dispObj.nextDue = date2;
              } else {
                dispObj.nextDue = date1;
              }
            }
          }

          res.defectsByStatus.items.map(defect => {
            if (
              defect.vehicle !== null &&
              !["REPAIRED", "REVOKED"].includes(defect.status)
            ) {
              if (defect.vehicle.id === item.id) {
                if (defect.redTag === true) {
                  dispObj.redTagCounter++;
                  dispObj.redTag = true;
                }
                vehDefectCount++;
                dispObj.defectStatus = defect.status;
              }
            }
          });
          dispObj.defectCount = vehDefectCount;
          /*
          res.inspectionsByDueDate.items.map(inspection => {
            if (inspection.vehicle !== null) {
              if (inspection.vehicle.id == item.id) {
                dispObj.inspectionDue = true;
                dispObj.nextInspectionDue = inspection.nextInspectionDue;
              }
            }
          });
          */
          vehicleDispData.push(dispObj);
        });
      }
      let New = 0,
        RedTags = 0,
        OnTheFly = 0,
        DVIR = 0,
        drivers = 0;
      res.customerTeam.items.forEach(team => {
        if (team.empType === "Drivers") drivers++;
      });

      res.defectsByStatus.items.forEach(defect => {
        //if (defect.status == "NEW") New++;
        if (defect.redTag) RedTags++;
        if (
          defect.sourceType === "ONTHEFLY" ||
          defect.sourceType === "INSPECTION"
        )
          OnTheFly++;
        if (defect.sourceType === "DVIR") DVIR++;
      });
      setVehicleCount(res.vehicles.items.length);

      setNewDefects(res.defectsByStatus.items.length);
      setRedTags(RedTags);
      setOnTheFly(OnTheFly);
      setDvir(DVIR);
      setDriverCount(drivers);
      // let sortCounter = 0;
      let tempArr = vehicleDispData.filter(a => a.defectCount > 0);
      tempArr.sort((a, b) => {
        if (a.defectCount < b.defectCount) {
          // sortCounter++;
          // a.sort = sortCounter;
          return 1;
        }
        // b.sort = sortCounter;
        return -1;
      });
      let tempArr1 = tempArr.filter(a => a.redTag);
      tempArr1.sort((a, b) => {
        if (a.redTagCounter < b.redTagCounter) {
          // sortCounter++;
          // a.sort = sortCounter;
          return 1;
        }
        // b.sort = sortCounter;
        return -1;
      });
      let tempArr3 = [...tempArr1, ...tempArr, ...vehicleDispData];
      tempArr3 = new Set(tempArr3);
      tempArr3 = [...tempArr3];
      vehicleDispData = tempArr3;
      vehicleCardDispData = vehicleDispData;
      // vehicleDispData.sort((a, b) => {
      //   if (a.defectCount < b.defectCount) {
      //     // sortCounter++;
      //     // a.sort = sortCounter;
      //     return 1;
      //   }
      //   // b.sort = sortCounter;
      //   return -1;
      // });
      storeVehicleGrid(vehicleCardDispData);
      if (vehicleCardDispData.length <= 10) zoom = 2.0;
      else if (
        vehicleCardDispData.length > 10 &&
        vehicleCardDispData.length <= 20
      )
        zoom = 1.6;
      setVehiclesList(vehicleDispData);
      setInitialFetch(false);
      setShowNew(true);
      RenderGrid();
    } catch (error) {}
    spinnerService.hide("mySpinner");
  };
  useEffect(() => {
    // if (vehicleGrid !== undefined) {
    //   //if (vehicleGrid.length > 0) RenderGrid();
    //   //else
    //   getData();
    // } else getData();
    getData();
    // RenderGrid();
  }, []);

  const AbsoluteGrid = createAbsoluteGrid(VehicleCard);
  let RenderGrid = function() {
    if (vehicleCardDispData.length <= 0) vehicleCardDispData = vehicleGrid;
    let gridInput = {
      data: vehicleCardDispData,
      history: history
    };
    // getData();
    return (
      <AbsoluteGrid
        items={vehicleCardDispData}
        onMove={onMoveDebounced}
        dragEnabled={true}
        zoom={zoom}
        responsive={true}
        verticalMargin={20}
        itemWidth={100}
        itemHeight={120}
        animation="transform 300ms ease"
      />
    );
    // ReactDOM.render(
    //   <AbsoluteGrid
    //     items={vehicleDispData}
    //     onMove={onMoveDebounced}
    //     dragEnabled={true}
    //     zoom={zoom}
    //     responsive={true}
    //     verticalMargin={20}
    //     itemWidth={80}
    //     itemHeight={100}
    //     animation="transform 300ms ease"
    //   />,
    //   document.getElementById("grid")
    // );
  };
  var onMove = function(source, target) {
    source = _.find(vehicleCardDispData, { key: parseInt(source, 10) });
    target = _.find(vehicleCardDispData, { key: parseInt(target, 10) });

    const targetSort = target.sort;

    //CAREFUL, For maximum performance we must maintain the array's order, but change sort
    vehicleCardDispData = vehicleCardDispData.map(function(item) {
      //Decrement sorts between positions when target is greate
      if (item.key === source.key) {
        return {
          ...item,
          sort: targetSort
        };
      } else if (
        target.sort > source.sort &&
        (item.sort <= target.sort && item.sort > source.sort)
      ) {
        return {
          ...item,
          sort: item.sort - 1
        };
        //Increment sorts between positions when source is greater
      } else if (item.sort >= target.sort && item.sort < source.sort) {
        return {
          ...item,
          sort: item.sort + 1
        };
      }
      return item;
    });
    //Perf.start();

    RenderGrid();

    //Perf.stop();
    //Perf.printWasted();
  };
  var onMoveDebounced = _.debounce(onMove, 40);
  let zoom = 1.6;
  var renderDebounced = _.debounce(RenderGrid, 150);

  //Update the zoom value
  var onZoom = function(event) {
    zoom = parseFloat(event.target.value);
    renderDebounced();
  };
  const onFilter = e => {
    // var search = new RegExp(event.target.value, "i");
    vehicleCardDispData = vehicleCardDispData.filter(arr =>
      arr.customerVehicleId.toLowerCase().includes(e.toLowerCase())
    );
    // vehicleCardDispData.map(function(item) {
    //
    // const isMatched = !item.name.match(search);
    // if (!item.filtered || isMatched !== item.filtered) {
    //   return {
    //     ...item,
    //     filtered: isMatched
    //   };
    // }
    // return item;
    // });
    // document.getElementById("grid");
    RenderGrid();
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  const DefectDetailModel = () => {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={open}
          onClose={() => setOpen()}
        >
          <div
            style={{
              position: "absolute",
              width: "auto",
              backgroundColor: "white",
              // border: '2px solid #000',
              boxShadow: 5,
              padding: 25,
              top: 100,
              left: 200
            }}
          >
            <h4 id="simple-modal-title">Totale Defect {defectsList.length}</h4>
            <Table>
              <TableHead>
                <TableCell>Defect Type</TableCell>
                <TableCell>Defect Description</TableCell>
                <TableCell>Reported Date & Time</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Source Type</TableCell>
                <TableCell>Red Tag</TableCell>
              </TableHead>
              <TableBody>
                {defectsList.map(defect => {
                  return (
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell>{defect.status}</TableCell>
                      <TableCell>{defect.sourceType}</TableCell>
                      <TableCell>{defect.redTag ? "true" : "false"}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </Modal>
      </div>
    );
  };
  return (
    <div>
      <Row>
        <Col xs={12} sm={6} lg={6}>
          <div style={{ float: "left" }}>
            <Avatar style={{ height: 80, width: 80 }}>
              <img src={logo} style={{ height: 80, width: 80 }} alt="..." />
            </Avatar>
          </div>
          <div style={{ float: "left", paddingLeft: 10, marginTop: 10 }}>
            <div style={{ fontSize: "24px" }}>{data.companyName}</div>
            <div style={{ marginTop: "10px" }}>
              Welcome{" "}
              {isDisp
                ? dispData.empName
                : data.customerFirstName + " " + data.customerLastName}
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={6}>
          {/* <div
            style={{
              float: "right",
              textAlign: "center",
              paddingLeft: 10,
              paddingRight: 10,
              marginTop: 10
            }}
          >
            <b>Drivers</b>
            <br />
            {driverCount > 0 && driverCount < 10
              ? "0" + driverCount
              : driverCount}
          </div>
          <div
            style={{
              float: "right",
              textAlign: "center",
              paddingLeft: 10,
              marginTop: 10
            }}
          >
            <b>Vehicles</b>
            <br />
            {vehicleCount > 0 && vehicleCount < 10
              ? "0" + vehicleCount
              : vehicleCount}
          </div> */}
          <div style={{ float: "right" }}>
            <IconButton
              onClick={() => {
                setShowNew(true);
                setView("");
              }}
            >
              <ListIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                // RenderGrid();
                setShowNew(false);
                setView("grid");
              }}
            >
              <AppsIcon />
            </IconButton>
          </div>
          {/* <div>
            {!showNew ? (
              <Typography
                onClick={() => {
                  setShowNew(true);
                }}
              >
                New Dashboard
              </Typography>
            ) : (
              <Typography
                onClick={() => {
                  setShowNew(false);
                }}
              >
                Old Dashboard
              </Typography>
            )}
          </div> */}
        </Col>
      </Row>
      {/* {showNew ? (
        <DashboardView data={vehiclesList} />
      ) : ( */}
      <Row style={{ marginTop: 10 }}>
        {view === "grid" && !showNew && (
          <Col sm={9}>
            <input
              placeholder="Filter by id"
              onChange={e => onFilter(e.target.value)}
              type="text"
            />
            {/* <ZoomOutIcon></ZoomOutIcon>
            <input
              onChange={onZoom}
              type="range"
              min="1.6"
              max="3.0"
              step="0.2"
              defaultValue={zoom}
            />
            <ZoomInIcon></ZoomInIcon> */}
            {/* <div style={{ float: "right" }}>
              <IconButton aria-label="delete">
                <AppsIcon />
              </IconButton>
            </div> */}
            <div id="grid" style={{ marginTop: 15 }}>
              <RenderGrid />
            </div>
          </Col>
        )}
        {/* {view === "list" && (
          <Col sm={9}>{<DashboardView data={vehiclesList} />}</Col>
        )} */}
        {showNew && (
          <Col>
            <DashboardView data={vehiclesList} customer={data} />{" "}
          </Col>
        )}
        {initialFetch && (
          <Col>
            <DashboardView data={vehiclesList} customer={data} />{" "}
          </Col>
        )}
        {/* {initialFetch && (
          <React.Fragment>
            <DashboardView data={vehiclesList} />
            <Col sm={3} style={{ marginTop: 40 }}>
              <Row style={{ marginBottom: 10 }}>
                <Col sm={6}>
                  <Button
                    onClick={() => {
                      setView("grid");
                      //RenderGrid();
                    }}
                  >
                    Grid View
                  </Button>
                </Col>
                <Col col={6} onClick={() => setView("list")}>
                  <Button>List View</Button>
                </Col>
              </Row>
              <ListGroup>
                <ListGroupItem
                  style={{ textAlign: "center" }}
                  active
                  tag="button"
                  action
                  onClick={() => setOpen(!open)}
                >
                  <Badge
                    style={{
                      width: 30,
                      height: 30,
                      marginRight: 5,
                      paddingTop: 10,
                      borderRadius: "50%"
                    }}
                    href="#"
                    color="light"
                  >
                    {newDefects}
                  </Badge>
                  New Defects
                </ListGroupItem>
                <ListGroupItem
                  style={{ textAlign: "left" }}
                  tag="button"
                  action
                >
                  <div style={{ float: "left" }}>
                    <Badge
                      style={{
                        width: 30,
                        height: 30,
                        marginRight: 5,
                        padding: 0,
                        paddingTop: 10,
                        borderRadius: "50%"
                      }}
                      href="#"
                      color="dark"
                    >
                      {dvir}
                    </Badge>
                  </div>
                  <div>DVIR Defects/Write-ups</div>
                </ListGroupItem>
                <ListGroupItem
                  style={{ textAlign: "left" }}
                  tag="button"
                  action
                >
                  <div style={{ float: "left" }}>
                    <Badge
                      style={{
                        width: 30,
                        height: 30,
                        marginRight: 5,
                        padding: 0,
                        paddingTop: 10,
                        borderRadius: "50%"
                      }}
                      href="#"
                      color="dark"
                    >
                      {onTheFly}
                    </Badge>
                  </div>
                  <div>Defects/Write-ups Need Attention </div>
                </ListGroupItem>
                <ListGroupItem
                  style={{ textAlign: "left", color: "red" }}
                  tag="button"
                  color="red"
                  action
                >
                  {" "}
                  <div style={{ float: "left" }}>
                    <Badge
                      style={{
                        width: 30,
                        height: 30,
                        marginRight: 5,
                        padding: 0,
                        paddingTop: 10,
                        borderRadius: "50%"
                      }}
                      href="#"
                      color="danger"
                    >
                      {redTags}
                    </Badge>
                  </div>
                  <div>Red Tagged</div>
                </ListGroupItem>
              </ListGroup>
            </Col>
          </React.Fragment>
        )} */}
      </Row>
      {/* )} */}
      <DefectDetailModel />
    </div>
  );
};
const styles = {
  btn: {
    backgroundColor: "skyBlue"
  },
  root: {
    width: "100%",
    maxWidth: 500
    // backgroundColor: 'white',
  },
  inline: {
    display: "inline"
  }
};
const mapStateToProps = state => {
  return {
    user: state.config.user,
    loading: state.config.loading,
    client: state.config.client,
    profile: state.config.profile,
    vehicleGrid: state.vehicles.vehicleGrid
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeVehicleGrid: data => dispatch(actionTypes.storeVehicleGrid(data))
    // storeUser: data => dispatch(actionTypes.storeUser(data)),
    // storeClient: data => dispatch(actionTypes.storeClient(data))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerDashboardPage);



// WEBPACK FOOTER //
// ./src/customers/dashboard.js